//! DO NOT EDIT THIS FILE MANUALLY!
//! IT IS AUTO-GENERATED FROM: protos-core-geography/src/main/proto/faire/geography/languages.proto
//! RUN `yarn nx regenerate web-api` TO REGENERATE.

/**
 * Codes are ISO 639-3
 */
export enum Language {
  LANGUAGE_UNKNOWN = 'LANGUAGE_UNKNOWN',
  /**
   * English
   */
  ENG = 'ENG',
  /**
   * French
   */
  FRA = 'FRA',
  /**
   * German
   */
  DEU = 'DEU',
  /**
   * Spanish
   */
  SPA = 'SPA',
  /**
   * Italian
   */
  ITA = 'ITA',
  /**
   * Norwegian
   */
  NOR = 'NOR',
  /**
   * Swedish
   */
  SWE = 'SWE',
  /**
   * Dutch
   */
  NLD = 'NLD',
  /**
   * Portuguese
   */
  POR = 'POR',
  /**
   * Danish
   */
  DAN = 'DAN',
  /**
   * Gibberish as a language to support gibberish string mode.
   * This language uses special letters and is intended to look like a foreign language.
   * Use case: it mimics rendering a page in a language not yet launched
   */
  GIBBERISH = 'GIBBERISH',
  /**
   * String ID as a language to support string ID mode.
   * This language corresponds to string ID mode and converts Faire generated contents to their ID.
   * Use case: this helps engineers and language managers to quick locate a string.
   */
  STRING_ID = 'STRING_ID',
  /**
   * Polish
   */
  POL = 'POL',
  /**
   * Raw / locale-neutral sentinel.
   * Used as a cache key for protos whose translatable fields hold raw column values rather than
   * any localized text. The wire-cache layer pairs entries cached under RAW with a per-request
   * localize step that applies user-locale translations on top.
   */
  RAW = 'RAW',
}
